"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importDefault(require("react"));

var theme_1 = require("../../styles/theme");

var HelperElement = styled_1["default"]('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: none;\n  left: -10000px;\n  position: absolute;\n  top: -10000px;\n  visibility: hidden;\n"], ["\n  display: none;\n  left: -10000px;\n  position: absolute;\n  top: -10000px;\n  visibility: hidden;\n"])));
var DesktopDown = styled_1["default"](HelperElement)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", " {\n    display: inline;\n  }\n"], ["\n  ", " {\n    display: inline;\n  }\n"])), theme_1.theme.breakpoints.desktopDown);
var DesktopUp = styled_1["default"](HelperElement)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", " {\n    display: inline;\n  }\n"], ["\n  ", " {\n    display: inline;\n  }\n"])), theme_1.theme.breakpoints.desktopUp);
var LargeDesktopUp = styled_1["default"](HelperElement)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", " {\n    display: inline;\n  }\n"], ["\n  ", " {\n    display: inline;\n  }\n"])), theme_1.theme.breakpoints.largeDesktopUp);
var MobileUp = styled_1["default"](HelperElement)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", " {\n    display: inline;\n  }\n"], ["\n  ", " {\n    display: inline;\n  }\n"])), theme_1.theme.breakpoints.mobileUp);
var SmallTabletDown = styled_1["default"](HelperElement)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", " {\n    display: inline;\n  }\n"], ["\n  ", " {\n    display: inline;\n  }\n"])), theme_1.theme.breakpoints.smallTabletDown);
var SmallTabletUp = styled_1["default"](HelperElement)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", " {\n    display: inline;\n  }\n"], ["\n  ", " {\n    display: inline;\n  }\n"])), theme_1.theme.breakpoints.smallTabletUp);
var TabletDown = styled_1["default"](HelperElement)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", " {\n    display: inline;\n  }\n"], ["\n  ", " {\n    display: inline;\n  }\n"])), theme_1.theme.breakpoints.tabletDown);
var TabletLandscapeDown = styled_1["default"](HelperElement)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", " {\n    display: inline;\n  }\n"], ["\n  ", " {\n    display: inline;\n  }\n"])), theme_1.theme.breakpoints.tabletLandscapeDown);
var TabletLandscapeUp = styled_1["default"](HelperElement)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", " {\n    display: inline;\n  }\n"], ["\n  ", " {\n    display: inline;\n  }\n"])), theme_1.theme.breakpoints.tabletLandscapeUp);
var TabletUp = styled_1["default"](HelperElement)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", " {\n    display: inline;\n  }\n"], ["\n  ", " {\n    display: inline;\n  }\n"])), theme_1.theme.breakpoints.tabletUp);
var WidgetUp = styled_1["default"](HelperElement)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", " {\n    display: inline;\n  }\n"], ["\n  ", " {\n    display: inline;\n  }\n"])), theme_1.theme.breakpoints.widgetUp);
/**
 * Returns a map of all breakpoints and a boolean for each indicating if it's visible
 */

function getBreakpointStatus() {
  return ["desktopDown", "desktopUp", "largeDesktopUp", "mobileUp", "smallTabletDown", "smallTabletUp", "tabletDown", "tabletLandscapeDown", "tabletLandscapeUp", "tabletUp", "widgetUp"].reduce(function (result, name) {
    var _a;

    var element = document.getElementById("brk-" + name);
    return __assign(__assign({}, result), (_a = {}, _a[name] = window.getComputedStyle(element).display !== 'none', _a));
  }, {});
}

exports.getBreakpointStatus = getBreakpointStatus;

exports["default"] = function () {
  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(DesktopDown, {
    id: "brk-desktopDown"
  }), react_1["default"].createElement(DesktopUp, {
    id: "brk-desktopUp"
  }), react_1["default"].createElement(LargeDesktopUp, {
    id: "brk-largeDesktopUp"
  }), react_1["default"].createElement(MobileUp, {
    id: "brk-mobileUp"
  }), react_1["default"].createElement(SmallTabletDown, {
    id: "brk-smallTabletDown"
  }), react_1["default"].createElement(SmallTabletUp, {
    id: "brk-smallTabletUp"
  }), react_1["default"].createElement(TabletDown, {
    id: "brk-tabletDown"
  }), react_1["default"].createElement(TabletLandscapeDown, {
    id: "brk-tabletLandscapeDown"
  }), react_1["default"].createElement(TabletLandscapeUp, {
    id: "brk-tabletLandscapeUp"
  }), react_1["default"].createElement(TabletUp, {
    id: "brk-tabletUp"
  }), react_1["default"].createElement(WidgetUp, {
    id: "brk-widgetUp"
  }));
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;